import z from "zod";
import { DayOfWeek } from "@/openapi/generated";

export const appointmentHourSchema = z
  .object({
    teacherId: z.number().min(1, { message: "Teacher ID is required" }),
    day: z.nativeEnum(DayOfWeek, {
      message: "Please select a day of the week",
    }),
    startTime: z.string().min(1, { message: "Start time is required" }),
    endTime: z.string().min(1, { message: "End time is required" }),
    locationId: z.number({ message: "Location is required" }).min(1, {
      message: "Location is required",
    }),
  })
  .refine(
    (data) => {
      const start = data.startTime;
      const end = data.endTime;
      if (start && end) {
        return end > start;
      }
      return true;
    },
    {
      message: "End time must be after start time",
      path: ["endTime"],
    },
  );

export type AppointmentHourSchemaType = z.infer<typeof appointmentHourSchema>;
